<template>
<easy-data-table
	class="data-table m-1 mt-0 me-1"
	table-class-name="customize-table"
	:headers="tableHeaders"
	:items="tableItems"
	:loading="isTableLoading"
	:filter-options="filterOptions"
	theme-color="rgb(198, 199, 200)"
	sort-by="time"
	sort-type="desc"
	:rows-items="[10,20,40,100]"
	:rows-per-page="easyDataTableRowsPerPage()"
	rows-per-page-message="записів на сторінці"
	rows-of-page-separator-message=" з "
	:table-min-height="380"
	:table-height="easyDataTableHeight()"
	:prevent-context-menu-row="false"
	alternating
	buttons-pagination
>
	<!-- If rows is empty -->
	<template #empty-message>
		записів не знайдено
	</template>

	<template #loading>
		<div class="spinner-border" style="width: 3rem; height: 3rem;" role="status">
			<span class="visually-hidden">Loading...</span>
		</div>
	</template>

	<!-- Filter to organization column -->
	<template #[orgNameHeaderSlotName]="header">
		<!-- Don't create if criterias is empty because form will empty -->
		<table-filter-checkboxes
			v-if="!isTableLoading && organizationCriterias.length > 0"
			:criterias="organizationCriterias"
			:default-checked="organizationCriterias"
			@checked-criterias="(criterias) => { filters['organization'] = criterias }"
		/>
		{{ header.text }}
	</template>

	<!-- Filter to actor column -->
	<template #header-actor="header">
		<!-- Don't create if criterias is empty because form will empty -->
		<table-filter-checkboxes
			v-if="!isTableLoading && actorCriterias.length > 0"
			:criterias="actorCriterias"
			:default-checked="actorCriterias"
			@checked-criterias="(criterias) => { filters['actor'] = criterias }"
		/>
		{{ header.text }}
	</template>

	<!-- Filter to diff column (filters by passportKey field) -->
	<template #header-diff="header">
		<!-- Don't create if criterias is empty because form will empty -->
		<table-filter-checkboxes
			v-if="!isTableLoading && passportKeyCriterias.length > 0"
			:criterias="passportKeyCriterias"
			:default-checked="passportKeyCriterias"
			show-search
			@checked-criterias="(criterias) => { filters['passportKey'] = criterias.map((el) => el == $options.SERVICE_KEY_TITLE ? '' : el) }"
		/>
		{{ header.text }}
	</template>

	<!-- Time item customization -->
	<template #item-time="{ time }">
		{{ dateTimeToString(time, false) }}
	</template>

	<template #[postNameSlotName]="item">
		<div
			class="p-0 m-0"
			style="cursor: pointer;"
			@click="onClickPostName(item[Post.passportKeys.name])"
		>
			{{ item[Post.passportKeys.name] }}
		</div>
	</template>

	<!-- Diff item customization -->
	<template #item-diff="{ action, diff, }">
			<template v-if="action == '' && !diff">
				<span class="fw-semibold">Початок фіксації історії змін</span>
			</template>

			<template v-else-if="action == '' && diff">
				<span class="fst-italic text-decoration-underline">
					{{ settingName(diff[0]) }}
				</span>
				&nbsp;{{ parseValue(diff[1].oldValue) }} -> {{ parseValue(diff[1].newValue) }}<br/>
			</template>

			<template v-else-if="action != ''">
				<span class="fw-semibold">{{ action }}</span><br/>
				<!-- <template v-for="(setting, index) in Object.entries(passport)" :key="index">
					<span v-if="
						![
							...Object.values(FIELD_NAMES),
							Post.passportKeys.metricsId,
							Post.passportKeys.creatorId, 
							Post.passportKeys.isRegistered,
							Post.passportKeys.notificationDistributionLists.self,
						].includes(setting[0])"
					>
						<span class="fst-italic text-decoration-underline">
							{{ Post.settingNames[setting[0]] ? Post.settingNames[setting[0]] : setting[0] }}
						</span>
						&nbsp;{{ parseValue(setting[1]) }}<br>
					</span>
				</template> -->
			</template>

			<template v-else>
				Неможливі зміни
			</template>
	</template>
</easy-data-table>
</template>




<script>
import TableFilterCheckboxes from '@/components/TableFilterCheckboxes.vue'
import { useAccontStore } from '@/stores/AccountStore.js'
import { usePostsStore } from '@/stores/PostsStore.js'
import { useStationsStore } from '@/stores/StationsStore.js'
import { useSessionStore } from '@/stores/SessionStore.js'
import { Post } from '@/models/post.js'
import {
	// timeFromNowPromt,
	dateTimeToString,
	easyDataTableHeight,
	easyDataTableRowsPerPage,
	getObjectDiff,
} from '@/helpers.js'
import { FIELD_NAMES, parseApiTimeDate } from '@/api/api.js'

export default {
	SERVICE_KEY_TITLE: 'Сервісні повідомлення',
	inject: [ 'headerHeight'],
	
	components: {
		TableFilterCheckboxes
	},

	setup() {
		const accountStore = useAccontStore()
		const postsStore = usePostsStore()
		const stationsStore = useStationsStore()
		const sessionStore = useSessionStore()

		return {
			accountStore,
			postsStore,
			stationsStore,
			sessionStore,
			Post,
			dateTimeToString,
			easyDataTableHeight,
			easyDataTableRowsPerPage,
			FIELD_NAMES,
		}
	},

	data() {
		return {
			// Table
			isTableLoading: true,
			// Filters
			filters: {
				actor: [],
				organization: [],
				passportKey: [],
				postName: [],
			},
			// For filter criterias
			organizationNames: new Set(),
			actorNames: new Set(),
			passportKeyNames: new Set(),
			postNames: new Set(),
			//
			tableItems: [],

			//
			departments: [],
		}
	},

	async created() {
		// Read all stations
		await this.stationsStore.readStations()
		// Read all posts
		await this.postsStore.readPosts()

		await this.updateHistory()
	},

	mounted() {
		document.title = "Історія налаштувань КВП"
	},

	methods: {
		async updateHistory() {
			this.isTableLoading = true

			this.tableItems.length = 0
			this.departments.length = 0
			
			for (const post of this.postsStore.postsArray) {
				const history = await this.postsStore.postPasportHistory(post.id)
				this.parsePostHistory(history)
			}

			this.filterByPostName()
			
			this.isTableLoading = false
		},

		parsePostHistory(history) {
			let prevRecord = undefined

			for (const record of history) {
				const orgName = record[Post.passportKeys.orgId][this.accountStore.schema.organization.title]
				const orgDepartments = record[Post.passportKeys.orgId][this.accountStore.schema.organization.departments.self]
				let actor = '-'
				let action = ''
				let diff = null
				const postName = record[Post.passportKeys.shortName]
					? record[Post.passportKeys.shortName]
					: record[Post.passportKeys.name]

				// If there is related stations
				if (record[Post.passportKeys.relatedStations]) {
					// Make stations list string with separator ','
					let stationNames = ''
					for (const stationId of record[Post.passportKeys.relatedStations]) {
						if (stationNames != '') {
							stationNames +=	', '
						}
						stationNames += '"' + this.stationsStore.station(stationId).passport.get('name') + '"'
					}

					record[Post.passportKeys.relatedStations] = stationNames
				}

				// If record was updated
				if (record[Post.passportKeys.updateBy]) {
					actor = record[Post.passportKeys.updateBy][this.accountStore.schema.name]
				// Else means record created
				} else {
					actor = record[Post.passportKeys.creatorId][this.accountStore.schema.name]
					action = 'КВП створено'
				}

				if (record && prevRecord) {
					diff = getObjectDiff(prevRecord, record)
					for (const key of Object.values(FIELD_NAMES)) {
						delete diff[key]
					}

					delete diff[Post.passportKeys.updateBy]
					delete diff[Post.passportKeys.creatorId]
				}

				if (diff) {
					for (const [name, setting] of Object.entries(diff)) {
						this.tableItems.push({
							time: parseApiTimeDate(record[FIELD_NAMES.updateTime]),
							[Post.passportKeys.name]: postName,
							actor: actor,
							[Post.passportKeys.orgName]: orgName,
							action: action,
							passport: record,
							passportKey: this.settingName(name),
							diff: [name, setting],
						})

						this.passportKeyNames.add(this.settingName(name))
					}
				} else {
					this.tableItems.push({
						time: parseApiTimeDate(record[FIELD_NAMES.updateTime]),
						[Post.passportKeys.name]: postName,
						actor: actor,
						[Post.passportKeys.orgName]: orgName,
						action: action,
						passport: record,
					})
				}

				this.postNames.add(String(postName))
				this.organizationNames.add(orgName)
				this.actorNames.add(actor)

				this.departments = this.departments.concat(orgDepartments)
				
				prevRecord = record
			}
		},

		// Column names
		colName (colId) {
			return this.columnNames.get(colId)
		},

		settingName(settingId) {
			if (settingId == Post.passportKeys.departmentId) {
				return this.accountStore.organization.department_title ? 
					this.accountStore.organization.department_title :
					Post.departmentDefaultTitle
			} else if (settingId == Post.passportKeys.sectorId) {
				return this.accountStore.organization.sector_title ? 
					this.accountStore.organization.sector_title :
					Post.sectorIdDefaultTitle
			} else if (Post.settingNames[settingId]) {
				return Post.settingNames[settingId]
			} else {
				return settingId
			}
		},

		departmentName(departmentId) {
			const department = this.departments.find((el) => el.id == departmentId)
			return department ? department[this.accountStore.schema.organization.departments.title] : null
		},

		sectorName(sectorId) {
			let name = null
			for (const department of this.departments) {
				for (const sector of department[this.accountStore.schema.organization.departments.sectors]) {
					if (sector.id == sectorId) {
						name = sector.title
					}
				}
			}
			return name
		},

		parseValue(value) {
			if (Object.prototype.toString.call(value) === '[object Date]') {
				return dateTimeToString(value)
			} else if (value === true || value === false) {
				return value ? 'так' : 'ні'
			} else if (this.departmentName(value)) {
				return this.departmentName(value)
			} else if (this.sectorName(value)) {
				return this.sectorName(value)
			} else if (Object.prototype.toString.call(Post.postControlType[value]) == '[object Object]') {
				return Post.postControlType[value].title
			} else if (value === null || value === undefined || value == '') {
				return 'не задано'
			} else {
				return value
			}
		},

		// If name == null - reset filter
		filterByPostName(name=null) {
			if (name == null) {
				this.filters.postName = this.postNameCriterias
			} else {
				this.filters.postName = [name, ]
			}
		},

		onClickPostName(name) {
			if (this.filters.postName.length <= 1) {
				this.filterByPostName()
			} else {
				this.filterByPostName(name)
			}
		},
	},

	computed: {
		orgNameHeaderSlotName() {
			return "header-" + Post.passportKeys.orgName
		},

		postNameSlotName() {
			return "item-" + Post.passportKeys.name
		},

		actorCriterias() {
			return [ ...this.actorNames ]
		},

		organizationCriterias() {
			return [ ...this.organizationNames ]
		},

		passportKeyCriterias() {
			return [ ...this.passportKeyNames, this.$options.SERVICE_KEY_TITLE ]
		},

		postNameCriterias() {
			return [ ...this.postNames ]
		},

		columnNames() {
			return new Map([
				['time', 'Час'],
				[Post.passportKeys.name,'Назва'],
				['actor', 'Користувач'],
				[Post.passportKeys.orgName,'Організація'],
				['diff','Зміни відносно попереднього'],
			])
		},

		tableHeaders() {
			let headers = []

			headers.push({ text: this.colName('time'), value: 'time', width: 100, })
			headers.push({ text: this.colName(Post.passportKeys.name), value: Post.passportKeys.name, width: 200, })
			headers.push({ text: this.colName('actor'), value: 'actor', width: 200, })
			if (this.accountStore.isPrimary) {
				headers.push({ text: this.colName(Post.passportKeys.orgName), value: Post.passportKeys.orgName, width: 300,})
			}
			headers.push({ text: this.colName('diff'), value: 'diff' },)

			return headers
		},

		filterOptions() {
			const filterOptionsArray = new Array()
	
			filterOptionsArray.push({
				field: 'actor',
				comparison: 'in',
				criteria: this.filters.actor,
			})

			if (this.accountStore.isPrimary) {
				filterOptionsArray.push({
					field: Post.passportKeys.orgName,
					comparison: 'in',
					criteria: this.filters.organization,
				})
			}

			filterOptionsArray.push({
				field: 'passportKey',
				comparison: 'in',
				criteria: this.filters.passportKey,
			})

			filterOptionsArray.push({
				field: Post.passportKeys.name,
				comparison: 'in',
				criteria: this.filters.postName,
			})

			return filterOptionsArray;
		},
	},
}
</script>




<style src="@/assets/table.css" scoped></style>